<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { isSequenceRunning } from 'src/helpers/xt1_helpers/irrigation/irrigation_helpers';
	//Components
	import TemplateToggleSettings from '../Components/TemplateToggleSettings.svelte';
	import IrrigationConfirmModal from './IrrigationConfirmModal.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let confirmModal: IrrigationConfirmModal;
</script>

<Alert
	class="mb-s"
	heading={$format('xt1_alert_weather_api', {
		default:
			'Irrigation duration is adjusted based on weather API data: average temperature over the past 6 hours and precipitation in the last 24 hours.',
	})}
/>
<TemplateToggleSettings
	{device}
	setting="weather_api"
	title={$format('enable', { default: 'Enable' })}
	{confirmModal}
/>

{#if isSequenceRunning(device)}
	<IrrigationConfirmModal bind:this={confirmModal} />
{/if}
